import { useTranslation } from "react-i18next";
import { useCallRecordings } from "@/features/call/hooks/useCallRecordings";

interface PastRecordingsProps {
  callId: string;
}

export const PastRecordings = ({ callId }: PastRecordingsProps) => {
  const { t } = useTranslation();
  const { recordings, loading, error } = useCallRecordings(callId);

  if (loading) {
    return (
      <div className="flex items-center gap-2 text-slate-400 text-sm py-4">
        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-slate-400" />
        <span>{t("call.loading_recordings")}</span>
      </div>
    );
  }

  if (error) {
    return null;
  }

  const mp4Recordings = recordings.filter((rec) =>
    rec.filename.toLowerCase().endsWith(".mp4"),
  );

  if (!mp4Recordings.length) {
    return null;
  }

  return (
    <ul className="space-y-2">
      {mp4Recordings.map((rec) => (
        <li
          key={rec.filename}
          className="flex items-center justify-between gap-4 p-3 rounded-lg bg-slate-800"
        >
          <div className="min-w-0">
            <p className="text-white text-sm font-medium truncate">
              {rec.filename}
            </p>
            <p className="text-slate-400 text-xs mt-0.5">
              {new Date(rec.start_time).toLocaleString()} &mdash;{" "}
              {new Date(rec.end_time).toLocaleString()}
            </p>
          </div>
          <a
            href={rec.url}
            target="_blank"
            rel="noopener noreferrer"
            className="shrink-0 text-sm px-3 py-1.5 rounded-full bg-indigo-600 hover:bg-indigo-700 text-white transition-colors"
          >
            {t("call.download_mp4")}
          </a>
        </li>
      ))}
    </ul>
  );
};
